import { KnowledgeQuestionSelectContent } from './KnowledgeQuestionSelectContent';
export default KnowledgeQuestionSelectContent;